export default "__VITE_ASSET__dAyUlt9R__"